"use strict";

import Swiper, {Navigation, Pagination, EffectFade, Autoplay} from 'swiper';

window.$ = window.jQuery = require('jquery');
$.scrollTo = jQuery.scrollTo = require('jquery.scrollto');
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';

import A11yDialog from 'a11y-dialog';

// import smoothscroll from 'smoothscroll-polyfill';
// import smoothscrollAnchorPolyfill from 'smoothscroll-anchor-polyfill';
//
// smoothscroll.polyfill();
//
// import ScrollSpy from "bootstrap/js/src/scrollspy";

// var ajaxify = require("./ajaxify");
// ajaxify(window);

// var scrollTrigger = require('@terwanerik/scrolltrigger').default;

require("picturefill");
require("magnific-popup");

let timeoutId = null;
const documentHeight = () => {
    clearTimeout(timeoutId); // avoid execution of previous timeouts
    timeoutId = setTimeout(() => {
        const doc = document.documentElement;
        doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
    }, 200);
};
window.addEventListener("resize", documentHeight);
documentHeight();

var $w;
var $menu;
var controller;
var $scrollTrigger;
var scrollReverse = false;
var scrollDivider = 2;
var dialog;
var swipers = [];

function onResize() {
    var winHeight = $(window).height();
    var docHeight = $(document).height();
    var scrollSpace = docHeight - winHeight;

    if (scrollReverse) {
        $('[class~="background-fixed"]').each(function () {
            var sectionHeight = $(this).outerHeight();

            $(this).find(".i").each(function () {
                $(this).css({
                    height:
                        (sectionHeight + Math.abs(scrollSpace / scrollDivider)) + "px"
                });
            });
        });
    }
}

function onScroll() {
    var scrollPos = window.scrollY;
    var direction = scrollReverse ? 1 : -1;

    $('[class~="background-fixed"]').each(function () {
        $(this).find(".i").each(function () {
            $(this).find("img").css({transform: "translateY(" + (direction * (($(this).offset().top - scrollPos) / scrollDivider)) + "px)"});
        });
    });

    window.requestAnimationFrame(onScroll);
}

function changeBg($this) {
    var $n = $("> div.backgrounds", $this).find(".show").next();
    $("> div.backgrounds div.i", $this).removeClass("show");
    if ($n.length === 0) {
        $("> .backgrounds", $this).find("div.i").eq(0).addClass("show");
    } else {
        $n.addClass("show");
    }
}

function toggleNav(event) {
    // Stop default action and bubbling
    event.stopPropagation();
    event.preventDefault();

    if (jQuery(".menu-button").attr('aria-expanded') === 'true') {
        dialog.hide();
    } else {
        dialog.show();
    }

    jQuery(".menu-button").attr('aria-expanded', function (i, attr) {
        return attr === 'true' ? 'false' : 'true'
    });
}

// $(window).on('before-ajax-pageload', function (relativeUrl) {
//     $("body").addClass('loading');
// });
//
// $(window).on('after-ajax-pageload', function (relativeUrl) {
//     $("body").removeClass('loading');
// });

jQuery(function ($) {
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");

    $w = $(window);

    $menu = $("body > header");

    const element = document.getElementById('mobilnav');
    if (element) {
        dialog = new A11yDialog(element);
        dialog.on('hide', function (element, event) {
            toggleNav(event);
        });
    }

    $('.menu-button')
        .on('click', toggleNav)
        .on("keydown", function (event) {
            if (event.key === " " || event.key === "Enter" || event.key === "Spacebar") { // "Spacebar" for IE11 support
                event.preventDefault();
                toggleNav(event);
            }
        });

    // Click-Handler for a11y-Menu
    $("body").on("click", "button.menu-btn", function () {
        toggleSubNav(jQuery(this).attr('id'))
    });

    $w.resize(onResize);
    // $w.resize(onScroll);
    $w.resize();
    // $w.scroll(onScroll);
    // $w.scroll();

    window.requestAnimationFrame(onScroll);

    $(".page-row, .content-row").each(function () {
        var $this = $(this);
        if ($this.find("> .backgrounds .i").length > 1) {
            setInterval(changeBg, 2000, $this);
            changeBg($this);
        } else {
            changeBg($this);
        }
    });

    $('.swiper-container.slider').each(initSliderGallery);
    $('.swiper-container.gallery').each(initPictureSliderGallery);

    // $scrollTrigger = new scrollTrigger({
    //     trigger: {
    //         once: true,
    //         offset: {
    //             viewport: {
    //                 y: 0.2
    //             }
    //         },
    //         toggle: {
    //             class: {
    //                 in: 'visible',
    //                 out: 'notvisible'
    //             },
    //         },
    //     }
    // });

    // $scrollTrigger
    //     .add('section.page-row[data-slideInLeft] > div.container')
    //     .add('section.page-row[data-slideInRight] > div.container')
    //     .add('section.page-row[data-slideInBottom] > div.container')
    //     .add('section.page-row[data-fadeIn] > div.container');

    $('.accordion').collapse();
});

$(window).on("load", function (e) {
    $(window).resize();
    // $(window).scroll();

    for (var i = 0; i < swipers.length; i++) {
        swipers[i].update();
    }
});

// jQuery(function ($) {
//     var galleries = [], rel;
//     $('a[class="lightbox"]').each(function () {
//         rel = $(this).prop("rel");
//         galleries.indexOf(rel) === -1 ? galleries.push(rel) : "";
//     });
//     $(galleries).each(function () {
//         $('a[rel="' + this + '"]').magnificPopup({type: 'image', mainClass: 'mfp-fade', gallery: {enabled: true}, closeBtnInside: false});
//     });
// });

const a11y = {
    prevSlideMessage: 'Vorherige Seite',
    nextSlideMessage: 'Nächste Seite',
    firstSlideMessage: 'Das ist die erste Seite',
    lastSlideMessage: 'Das ist die letzte Seite',
    paginationBulletMessage: 'Zu Seite {{index}} springen',
};

function initSliderGallery() {
    var num = {xs: 1, sm: 1, md: 1, lg: 1, xl: 1};

    var reduceMotion = true;
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: no-preference)");
    if (mediaQuery && mediaQuery.matches) {
        reduceMotion = false;
    }

    if (this.dataset.num) {
        try {
            num = JSON.parse(this.dataset.num);
        } catch (e) {
        }
    }

    var options = {
        loop: true,
        slidesPerView: num.xs,
        slidesPerGroup: num.xs,
        spaceBetween: 0,
        watchOverflow: true,
        centerInsufficientSlides: true,
        // cssMode: true,
        passiveListeners: false,
        a11y,

        modules: [Navigation, Pagination, EffectFade, Autoplay],

        effect: (this.dataset.anim === "fade" || reduceMotion ? "fade" : "slide"),

        fadeEffect: {
            crossFade: true
        },

        // // If we need pagination
        // pagination: {
        //     el: (this.dataset.id ? '#swiper-pagination-' + this.dataset.id : '.swiper-pagination'),
        //     clickable: true,
        // },

        // Navigation arrows
        navigation: {
            nextEl: (this.dataset.id ? '#swiper-button-next-' + this.dataset.id : '.swiper-button-next'),
            prevEl: (this.dataset.id ? '#swiper-button-prev-' + this.dataset.id : '.swiper-button-prev'),
        },

        // // And if we need scrollbar
        // scrollbar: {
        //     el: (this.dataset.id ? '#swiper-scrollbar-' + this.dataset.id : '.swiper-scrollbar'),
        // },

        breakpoints: {
            // when window width is > 576px
            576: {
                slidesPerView: num.sm,
                slidesPerGroup: num.sm,
            },
            // when window width is > 768px
            768: {
                slidesPerView: num.md,
                slidesPerGroup: num.md,
            },
            // when window width is > 992px
            992: {
                slidesPerView: num.lg,
                slidesPerGroup: num.lg,
            },
            // when window width is > 1200px
            1200: {
                slidesPerView: num.xl,
                slidesPerGroup: num.xl,
            }
        },

        on: {
            init: function (swiper) {
                var elements = swiper.el.getElementsByTagName('a');
                for (var n = 0; n < elements.length; ++n) {
                    if (elements[n].className === "lightbox") {
                        elements[n].onclick = function (event) {
                            event.preventDefault();
                        };
                    }
                }
            },
            click: function (swiper, event) {
                var images = [];
                jQuery(this.slides).find("a.lightbox").each(function () {
                    images.push({src: jQuery(this).attr("href")});
                });
                if (images.length > 0) {
                    jQuery.magnificPopup.open({
                        items: images,
                        gallery: {
                            enabled: true
                        },
                        type: 'image',
                        closeBtnInside: false
                    }, this.clickedIndex);
                }
                return false;
            }
        },
    }

    if (parseInt(this.dataset.swiperAutoplay, 10) > 0) {
        options = Object.assign(options, {
            autoplay: reduceMotion ? false : {
                delay: parseInt(this.dataset.swiperAutoplay, 10),
                disableOnInteraction: false,
            },
            speed: reduceMotion ? 0 : 750,
            loop: true
        });
    }

    swipers.push(new Swiper(this.getElementsByClassName("swiper")[0], options));
}

function initPictureSliderGallery() {
    var num = 3;

    var reduceMotion = true;
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: no-preference)");
    if (mediaQuery && mediaQuery.matches) {
        reduceMotion = false;
    }

    if (this.dataset.num) {
        num = this.dataset.num;
    }

    swipers.push(new Swiper(this.getElementsByClassName("swiper")[0], {
        loop: false,
        spaceBetween: 0,
        watchOverflow: true,
        centerInsufficientSlides: true,
        // centeredSlides: true,
        // cssMode: true,
        passiveListeners: false,
        a11y,

        modules: [Navigation, Pagination, EffectFade, Autoplay],

        effect: (this.dataset.anim === "fade" || reduceMotion ? "fade" : "slide"),

        // Navigation arrows
        navigation: {
            nextEl: (this.dataset.id ? '#swiper-button-next-' + this.dataset.id : '.swiper-button-next'),
            prevEl: (this.dataset.id ? '#swiper-button-prev-' + this.dataset.id : '.swiper-button-prev'),
        },

        slidesPerView: 'auto',
        slidesPerGroup: 1,

        on: {
            init: function (swiper) {
                var elements = swiper.el.getElementsByTagName('a');
                for (var n = 0; n < elements.length; ++n) {
                    if (elements[n].className === "lightbox") {
                        elements[n].onclick = function (event) {
                            event.preventDefault();
                        };
                    }
                }
            },
            click: function (swiper, event) {
                var images = [];
                jQuery(this.slides).find("a.lightbox").each(function () {
                    images.push({src: jQuery(this).attr("href")});
                });
                jQuery.magnificPopup.open({
                    items: images,
                    gallery: {
                        enabled: true
                    },
                    type: 'image',
                    closeBtnInside: false
                }, this.clickedIndex);
                return false;
            }
        }
    }));
}

// jQuery(function ($) {
//     var galleries = [], rel;
//     $('a[class="lightbox"]').each(function () {
//         rel = $(this).prop("rel");
//         galleries.indexOf(rel) === -1 ? galleries.push(rel) : "";
//     });
//     $(galleries).each(function () {
//         $('a[rel="' + this + '"]').magnificPopup({
//             type: 'image', removalDelay: 300, mainClass: 'mfp-fade', gallery: {enabled: true}, closeBtnInside: false,
//             fixedContentPos: true, fixedBgPos: true,
//             image: {
//                 titleSrc: function (item) {
//                     return item.el.find('img').attr('title');
//                 }
//             }
//         });
//     });
// });

function toggleSubNav(eID) {
    try {
        // Get all the top-level items and get the buttons
        // var allButtons = document.querySelectorAll("#nav ul > li > a + button");
        var allButtons = jQuery("#" + eID).closest('ul').find("button");
        // Get all sub-menus
        // var allSubMenus = document.querySelectorAll("#nav ul > li > a + button + div");
        var allSubMenus = jQuery("#" + eID).closest('ul').find("button + *");
        if (eID !== "") {
            // Get the button
            var toggle = document.querySelector("#" + eID);
            // Find out what the button controls
            var subMenuIdent = toggle.getAttribute("aria-controls");
            // Get that thing it controls
            var subMenu = document.getElementById(subMenuIdent);
            // Toggle text and expanded state
            if (toggle.getAttribute("aria-expanded") === "false") {
                // Loop through all buttons and mark as closed
                for (var i = 0; i < allButtons.length; i++) {
                    allButtons[i].setAttribute("aria-expanded", "false");
                    // allButtons[i].setAttribute("aria-label", "Show");
                    //   allButtons[i].innerHTML = arrowShow;
                }
                // Now mark the chosen button as opened
                toggle.setAttribute("aria-expanded", "true");
                // toggle.setAttribute("aria-label", "Hide");
            } else {
                // Close chosen button; no need to loop through rest of nodes
                toggle.setAttribute("aria-expanded", "false");
                // toggle.setAttribute("aria-label", "Show");
            }
            // Expand or collapse
            // if (subMenu.style.display === "none") {
            if (subMenu.classList.contains("d-none")) {
                // Hide all submenus
                for (var i = 0; i < allSubMenus.length; i++) {
                    // allSubMenus[i].style.display = "none";
                    allSubMenus[i].classList.add("d-none");
                }
                // Show chosen submenu
                // subMenu.style.display = "block";
                subMenu.classList.remove("d-none");
            } else {
                // Close chosen menu; no need to loop through rest of nodes
                // subMenu.style.display = "none";
                subMenu.classList.add("d-none");
            }
        }
        if (eID !== "") {
        } else {
            // Hide all submenus
            for (var i = 0; i < allSubMenus.length; i++) {
                // allSubMenus[i].style.display = "none";
                allSubMenus[i].classList.add("d-none");
            }
            // Loop through all buttons and mark as closed
            for (var i = 0; i < allButtons.length; i++) {
                allButtons[i].setAttribute("aria-expanded", "false");
                // allButtons[i].setAttribute("aria-label", "Show");
                // allButtons[i].innerHTML = arrowShow;
            }
        }
    } catch (e) {
        console.log("toggleSubNav(): " + e);
    }
}

document.onkeydown = function (evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) {
        isEscape = evt.key == "Escape" || evt.key == "Esc";
    } else {
        isEscape = evt.keyCode == 27;
    }
    if (isEscape) {
        //alert("Escape");
        toggleSubNav("");
    }
};
